// Used by both the existing renderer and the template-photo capacity preview.
export function resolvePrimaryStandardProductPhoto(
  input: { productImageUrlsOverride?: unknown; productFlatlayUrl?: string | null },
  product: any,
  selectedVariantImage: string,
): string {
  const overrideProvided = Array.isArray(input.productImageUrlsOverride);
  const override: string[] = overrideProvided
    ? (input.productImageUrlsOverride as string[]).filter((r): r is string => typeof r === "string" && r.length > 0)
    : [];
  const adgenRefs: string[] = Array.isArray(product?.adgenImageRefs)
    ? (product.adgenImageRefs as unknown[]).filter((r): r is string => typeof r === "string" && r.length > 0)
    : [];
  const mediaRefs: string[] = Array.isArray(product?.mediaJson)
    ? (product.mediaJson as unknown[]).filter((r): r is string => typeof r === "string" && r.length > 0)
    : [];
  const refs = overrideProvided ? override : (adgenRefs.length > 0 ? adgenRefs : mediaRefs);
  return input.productFlatlayUrl || selectedVariantImage || refs[0] || (typeof product?.imageUrl === "string" ? product.imageUrl : "");
}

export function resolveExtraStandardProductPhotos(
  input: { productImageUrlsOverride?: unknown; productFlatlayUrl?: string | null; includeAllSelectedProductPhotos?: boolean },
  product: any,
  selectedVariantImage: string,
): string[] {
  if (input.productFlatlayUrl) return [];
  if (!Array.isArray(input.productImageUrlsOverride)) return [];
  const primary = resolvePrimaryStandardProductPhoto(input, product, selectedVariantImage);
  const override = (input.productImageUrlsOverride as unknown[]).filter(
    (r): r is string => typeof r === "string" && r.length > 0,
  );
  const seen = new Set<string>([primary]);
  const extras: string[] = [];
  for (const url of override) {
    if (seen.has(url)) continue;
    seen.add(url);
    extras.push(url);
    if (input.includeAllSelectedProductPhotos !== true && extras.length >= 5) break;
  }
  return extras;
}
